import { createReducer } from 'redux-act'

import * as actions from './actions'
import { getCompletedPercentage } from './getCompletedPercentage'
import { getCompletedSteps } from './getCompletedSteps'
import initialState from './initialState'

const setQuizConfig = (state, quizConfig): any => ({ ...state, quizConfig })

const setQuestionsResponse = (state, { answers, questionType }): any => {
  return {
    ...state,
    quizSubmit: {
      ...state.quizSubmit,
      quizanswers: { ...state.quizSubmit.quizanswers, [questionType]: answers },
    },
  }
}

const setQuizResult = (state, outfitResult): any => ({ ...state, outfitResult })

const setQuizSubmit = (state, quizSubmit): any => ({ ...state, quizSubmit })

const getQuestions = (state): any => state.quizConfig.questions

const setCompletedStepsInit = (state): any => {
  return {
    ...state,
    completedSteps: getCompletedSteps(getQuestions(state), 0, 0),
  }
}

const getNextQuestionIndex: any = (state): any =>
  getQuestions(state).length <= state.currentQuestionIndex + 1 ? 0 : state.currentQuestionIndex + 1

const nextQuestion = (state): any => {
  const currentQuestionIndex = getNextQuestionIndex(state)
  const currentChoiceIndex = 0
  return {
    ...state,
    currentQuestionIndex,
    currentChoiceIndex,
    completedPercentage: getCompletedPercentage(
      getQuestions(state),
      currentQuestionIndex,
      currentChoiceIndex,
    ),
    completedSteps: getCompletedSteps(
      getQuestions(state),
      currentQuestionIndex,
      currentChoiceIndex,
    ),
  }
}

const getNextChoiceIndex = (state): any =>
  getQuestions(state)[state.currentQuestionIndex].choices.length <= state.currentChoiceIndex + 1
    ? state.currentChoiceIndex
    : state.currentChoiceIndex + 1

const nextChoice = (state): any => {
  const currentChoiceIndex = getNextChoiceIndex(state)
  return {
    ...state,
    currentChoiceIndex,
    completedPercentage: getCompletedPercentage(
      getQuestions(state),
      state.currentQuestionIndex,
      currentChoiceIndex,
    ),
    completedSteps: getCompletedSteps(
      getQuestions(state),
      state.currentQuestionIndex,
      currentChoiceIndex,
    ),
  }
}

const reducer = createReducer((on) => {
  on(actions.setQuizConfig, setQuizConfig)
  on(actions.setCompletedStepsInit, setCompletedStepsInit)
  on(actions.setQuestionsResponse, setQuestionsResponse)
  on(actions.setOutfitResult, setQuizResult)
  on(actions.setQuizSubmit, setQuizSubmit)
  on(actions.nextQuestion, nextQuestion)
  on(actions.nextChoice, nextChoice)
}, initialState)

export default reducer
